import Badge from "@mui/material/Badge";

const CustomBadge = ({ badgeContent, label, sx = {} }) => {
  const count = Number(badgeContent);
  return (
    <div className="relative inline-flex items-center justify-center whitespace-nowrap">
      {count > 0 ? (
        <Badge
          badgeContent={count}
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: "#FF3838",
              color: "#fff",
              fontSize: "9px",
              fontWeight: "600",
              height: "15px",
              minWidth: "15px",
              borderRadius: "50%",
              padding: "0 2px",
              top: "-2px",
              right: "-4px",
              zIndex: 1,
              ...sx,
            },
          }}
        >
          <span className="whitespace-nowrap">{label}</span>
        </Badge>
      ) : (
        <span className="whitespace-nowrap">{label}</span>
      )}
    </div>
  );
};

export default CustomBadge;

